import './Icon.css';
import { IconProps } from './iconType';

export const DragIcon: React.FC<IconProps> = ({
  size = 36,
  color,
  className,
}) => {
  return (
    <span
      className={['icon', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size, color }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill='none'
      >
        <path
          d='M16 21C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22C15 21.4477 15.4477 21 16 21ZM20 21C20.5523 21 21 21.4477 21 22C21 22.5523 20.5523 23 20 23C19.4477 23 19 22.5523 19 22C19 21.4477 19.4477 21 20 21ZM16 17C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17ZM20 17C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19C19.4477 19 19 18.5523 19 18C19 17.4477 19.4477 17 20 17ZM16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13ZM20 13C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15C19.4477 15 19 14.5523 19 14C19 13.4477 19.4477 13 20 13Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};
